import { useClient } from '@composables/use-clients';
import {
  GetRequestArgsType,
  PostRequestArgsType,
} from '@api/v1/types';
import { useTenantStore } from '@stores/tenant-store';
import { urls } from '@api/urls';
import { withTryCatch } from '@api/v1/error-handlers';

export type GetTeamEditorsArgsType = GetRequestArgsType & {
  teamCode: string;
};

export type PostTeamEditorBatchUpdatePayloadType = {
  tenantUserIds: Array<number>;
};

export type PostTeamEditorBatchUpdateArgsType = (
  PostRequestArgsType<PostTeamEditorBatchUpdatePayloadType> & {
    teamCode: string;
  }
);

export const apiFetchTeamEditors = async ({
  domain = useTenantStore().domain,
  teamCode,
  errorConfig = {},
  callbacks = {},
}: GetTeamEditorsArgsType) => {
  const impl = async () => {
    const { client } = useClient('auth');
    const res = await client.get({
      url: urls.v1.teamEditors({ domain, teamCode }),
    });
    return res;
  };

  return withTryCatch({ impl, errorConfig, callbacks });
};

export const apiBatchUpdateTeamEditors = async ({
  domain = useTenantStore().domain,
  teamCode,
  payload,
  errorConfig = {},
  callbacks = {},
}: PostTeamEditorBatchUpdateArgsType) => {
  const impl = async () => {
    const { client } = useClient('auth');
    const res = await client.post({
      url: urls.v1.teamEditorBatchUpdate({ domain, teamCode }),
      payload,
    });
    return res;
  };

  return withTryCatch({ impl, errorConfig, callbacks });
};
